export default "__VITE_ASSET__DURQ4uO6__"